import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AuthenticationDataService } from 'app/core/authentication';
import { UrlService } from 'app/core/http/url.service';
import { WrappedString } from 'app/core/kh-utils/wrapped-string';

@Injectable({
  providedIn: 'root'
})
export class ExternalUrlService {
  private readonly httpClient = inject(HttpClient);
  private readonly urlService = inject(UrlService);
  private readonly authenticationDataService = inject(AuthenticationDataService);

  public getExternalUrlObs(customUrl: string, localeId?: string): Observable<WrappedString> {
    if (!localeId) {
      localeId = this.authenticationDataService.getUserLocale();
    }

    const url = this.urlService.buildServerApiUrl('ExternalUrl', localeId, customUrl);

    return this.httpClient.get<WrappedString>(url);
  }
}
